import { useMemo } from 'react';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { LegacyDynamicFormTable } from '~/legacy-components/LegacyDynamicFormTable';
import { LegacyFAIcon, LegacyFAIcons } from '~/legacy-components/LegacyFAIcon';
import { LegacyHeadingWithActions } from '~/legacy-components/LegacyLayout';

import { useEmployeeDocuments } from './useEmployeeDocuments';

export const EmployeeDocuments = () => {
  const { t } = useTranslation();

  const { useFormMethods, readData } = useEmployeeDocuments();

  const headers = useMemo(() => {
    return [
      { title: t('laDocumentType'), width: '164px', required: true },
      { title: t('laCreatedTime'), width: '120px' },
      { title: t('laModifiedTime'), width: '120px' },
      { title: t('laDocumentName'), width: '250px', required: true },
      { title: '', width: '250px' },
      { title: '', width: '120px' },
      { title: '', width: '82px' },
      { title: '', width: '102px' },
    ];
  }, [t]);

  const FormTableHeader = useMemo(() => {
    return (
      <LegacyHeadingWithActions
        headingIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.Table} />}
        heading={`${t('laEmpDocsReadOnly')}`}
      ></LegacyHeadingWithActions>
    );
  }, [t]);

  const TableComponent = useMemo(() => {
    return (
      <LegacyDynamicFormTable
        headers={headers}
        readData={readData}
        control={useFormMethods.control as unknown as Control}
        editData={[]}
        editMode={false}
        formTableHeader={FormTableHeader}
      />
    );
  }, [FormTableHeader, headers, readData, useFormMethods.control]);

  return <>{TableComponent}</>;
};
